import {EColumnDataType, ITableColumn} from '@relayter/rubber-duck';

export class SearchIndexTableConfig {
    public static readonly SEARCH_INDEX_SCORE_COLUMN: ITableColumn = {
        title: 'Relevance', key: 'relevance', sortProperty: 'searchIndexScore', sortDuplicates: true, dataType: EColumnDataType.NUMBER
    };
}
